var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSentimentDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 16.25C5.19891 16.25 5.38968 16.329 5.53033 16.4697C5.67098 16.6103 5.75 16.8011 5.75 17V19C5.75 19.138 5.862 19.25 6 19.25H18C18.0663 19.25 18.1299 19.2237 18.1768 19.1768C18.2237 19.1299 18.25 19.0663 18.25 19V17C18.25 16.8011 18.329 16.6103 18.4697 16.4697C18.6103 16.329 18.8011 16.25 19 16.25C19.1989 16.25 19.3897 16.329 19.5303 16.4697C19.671 16.6103 19.75 16.8011 19.75 17V19C19.75 19.4641 19.5656 19.9092 19.2374 20.2374C18.9092 20.5656 18.4641 20.75 18 20.75H6C5.53587 20.75 5.09075 20.5656 4.76256 20.2374C4.43437 19.9092 4.25 19.4641 4.25 19V17C4.25 16.8011 4.32902 16.6103 4.46967 16.4697C4.61032 16.329 4.80109 16.25 5 16.25Z",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.7388 3.75C10.4907 3.75007 10.2515 3.84314 10.0686 4.01087C9.88574 4.17859 9.77235 4.40877 9.75083 4.656C9.59695 6.40842 9.56954 8.16964 9.66883 9.926C9.42183 9.939 9.17583 9.956 8.92883 9.973L7.43883 10.082C7.30761 10.0916 7.18113 10.1351 7.07177 10.2083C6.96241 10.2815 6.87392 10.3818 6.81496 10.4994C6.756 10.617 6.72858 10.7479 6.7354 10.8793C6.74221 11.0107 6.78302 11.1381 6.85383 11.249C7.91572 12.9111 9.28403 14.3561 10.8858 15.507L11.4828 15.936C11.6338 16.0444 11.815 16.1027 12.0008 16.1027C12.1867 16.1027 12.3679 16.0444 12.5188 15.936L13.1158 15.507C14.7176 14.3561 16.0859 12.9111 17.1478 11.249C17.2186 11.1381 17.2595 11.0107 17.2663 10.8793C17.2731 10.7479 17.2457 10.617 17.1867 10.4994C17.1277 10.3818 17.0393 10.2815 16.9299 10.2083C16.8205 10.1351 16.6941 10.0916 16.5628 10.082L15.0728 9.973C14.8263 9.95517 14.5796 9.9395 14.3328 9.926C14.4324 8.16967 14.4054 6.40844 14.2518 4.656C14.2303 4.4086 14.1168 4.17828 13.9337 4.01053C13.7505 3.84278 13.5112 3.74982 13.2628 3.75H10.7388Z",
    fill: "#4d4d4d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentimentDownload);
export default __webpack_public_path__ + "static/media/sentimentDownload.a0e732bd0d02b37c974db13a19819785.svg";
export { ForwardRef as ReactComponent };